import Label from "lib/Label";
import { Image } from "lib";
import show_password from "assets/images/show_password.svg";
import hide_password from "assets/images/hide_password.svg";
import { Col } from "react-bootstrap";
import "./index.scss";
import ErrorMessage from "lib/ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { setIsKeyDuplicate } from "redux/recursiveReducer";
import { mergeFields } from "helper/triggerButtonCallback";
import { verifyDocumentNumber } from "api/formDisplay";
import Toast from "components/ToastComponent";
import {
  setUploadLoading,
} from "redux/configurationReducer";
import { getDataBasedOnExpression, getDuplicateData } from "api/formDisplay"
import { setVerificationResponse } from "redux/uploadDocumentReducer";
import { setIsDuplicateFormInput,setSelectedData } from "redux/formDisplay";
import { useMemo } from "react";

// import { IndirectEval } from 'helper/indirectEval';
const Input = (props) => {
  const {
    tooltip,
    placeholder,
    label,
    value,
    onChange,
    default_value,
    onLoad,
    disabled,
    type,
    name,
    class_name,
    size,
    error,
    events,
    doc_type,
    isEditable, // is used when RM requests to resend certain fields to the applicant
    // when editable is true only that field will be editable and rest will be disabled
    selectedData ={}, //being used in eval,
    is_disabled,
    validators,
    setSelectedData,
    verify,
    autofill,
    doc_id_length,
    verification_id,
    formErr,
    setFormErr,
    clearFieldError,
    service_type,
    masking_type,
    uploadVerificationResponses,
    doc_number_validation,
    substring_exprn,populate,
    validate_duplication,
    validate_duplication_type,
    validate_duplication_by,
    error_messages,
    keys_to_consider,
    options_type,    // keys added to autofill data based on dropdown selection (user-hierarchy)

  } = props;

  const IndirectEval = (evalString) => {
    return eval(evalString);
  };
  const [newType,setType] = useState(type)
  const [messageToast, setMessageToast] = useState({ type: "", msg: "" });
  const errActive = error && error?.length !== 0;
  const errorClass = errActive ? "error_outline" : "";
  const [isUploading, setIsUploading] = useState(false);
  const isToggled = useSelector((state) => state.formData.isToggled);
  const isDuplicateFormInput = useSelector((state) => state.formData.isDuplicateFormInput);
  const copiedData = useSelector((state) => state.formData.copiedData);
  const subworkflows = useSelector(
    (state) => state.userInfo.workflowUser.subworkflows
  );
  const workflow_id = subworkflows?._id;

  const currentEmail = useSelector(
    (state) => state?.recursive?.recursiveFormData?.email
  );
  const existingEmails = useSelector((state) => state?.recursive?.saveData);
  const mandatoryExtraction = useSelector(
    (state) => state?.formData?.mandatoryExtraction
  );
  const organisation_id = useSelector(( state) => state.configurationReducer?.config)?.organisation_id
  const recursiveFormData = useSelector((state) => state.recursive?.recursiveFormData);
  const configurationId = useSelector((state) => state.conditionalRendering?.configurationId);
  const allOptionList = useSelector((state) => state.staticData?.allOptionList);

  useEffect(() => {
    if (populate) {
      const newValue = IndirectEval(populate);

      onChange({ target: { name: name, value: newValue } });
    }
  }, [populate]);
  

  const decryptedId = useSelector((state) => state.urlEncryption?.urlId);
  const paymentReducer = useSelector((state) => state.paymentReducer?.payment_details);
  const userInfo = {
    userId: decryptedId.userId,
    primaryWorkflowId: decryptedId.primaryWorkflowId,
    subWfId: decryptedId.subWfId,
  };
  const editIndex = useSelector((state) => state.recursive.editIndex);
  const dispatch = useDispatch();

  const [uniqueDataError, setUniqueDataError] = useState(false);
  const [gstInactiveError, setGstInactiveError] = useState(false);

  const onKeyUpCapture = async (item) => {
     
    let payload = {}, res;
    if (validate_duplication_by == 'organisation') {
    
      payload = {
        [`source_data.${name}`]: selectedData[name],
        organisation_id,
        workflow_id,
        name
      }
    } else {
      payload = {
        [`source_data.${name}`]: selectedData[name],
        configuration_id: configurationId
      }
    }
    if (validate_duplication) {  
      res =  await checkDuplicate(payload);
    }

    if(res?.data?.length == 0 || !validate_duplication){
      if (events) {
        IndirectEval(events?.onKeyUpCapture);
      }
    }
    if (events) {
      IndirectEval(events?.onKeyUpCapture);
    }
    if(verify  &&  verify == true){
      let document_number = selectedData[name];
      await docNumberExtraction(document_number,doc_type)
    }
    //This code has been commented out since it overwrote the documentNumberExtraction api output for GST.
    // if(substring_exprn && substring_exprn!==""){
    //   let doc_number = selectedData[name];
    //   if (doc_number?.length == doc_id_length) {
    //     await handleExpression(doc_number, substring_exprn)
    //   }
    //   }
  };


  const dependencyValues = (() => {
    return keys_to_consider?.map((key) => selectedData[key]);
  }, [keys_to_consider, selectedData]);

  const getFilteredOptions = (keysToConsider,optionKey) =>{
    let obj = keysToConsider?.reduce((acc, item) => {
      acc[item] = selectedData[item];
      return acc;
    }, {})
    if(obj){
    const filteredData = allOptionList?.filter((item) =>
      Object.entries(obj).every(([key, value]) => value !== undefined && item[key] === value)
  );  
  let optionArray = filteredData?.map((item) => item?.[optionKey]).filter((value) => value !== undefined); 
     optionArray = [...new Set(optionArray)]
     let result = {
      optionKey : optionKey,
      optionArray : optionArray
     }
      return result;
  }
}

  useEffect(() => {
    if (options_type === "autofill") {
      let filteredResult = getFilteredOptions(keys_to_consider,name)
      let filteredData = filteredResult?.optionArray
      if (filteredData && filteredData.length === 1) {
        if (selectedData[name] !== filteredData[0]) {
          dispatch(setSelectedData({ key: name, value: filteredData[0] }));
        }
      } else {
        if (selectedData[name] !== "") {
          dispatch(setSelectedData({ key: name, value: "" }));
        }
      }
    
    }
  }, [options_type, dependencyValues, name, dispatch])

  // const onBlurCapture = async (event) => {
  //   console.log("blur...........",event);
    
  //   let payload = {};
  //   if (validate_duplication_by == 'organisation') {
  //     payload = {
  //       // [`source_data.subworkflows.${event.target.name}`]: selectedData[event.target.name],
  //       [`source_data.${event.target.name}`]: selectedData[event.target.name],
  //       organisation_id
  //     }
  //   } else {
  //     payload = {
  //       // [`source_data.subworkflows.${event.target.name}`]: selectedData[event.target.name],
  //       [`source_data.${event.target.name}`]: selectedData[event.target.name],
  //       configuration_id: configurationId
  //     }
  //   }
  //   if (validate_duplication) {
  //     await checkDuplicate(payload);
  //   }
  // };

  const loadingText = useSelector(
    (state) => state.configurationReducer.loadingText
  );

  useEffect(() => {
    if (default_value && disabled) {
      onLoad(name, default_value);
    }
  }, [disabled]);

  useEffect(() => {
    if (masking_type) {
      setType(masking_type);
    }
  }, [masking_type]);

  const togglePassword =()=>{
    if(newType == masking_type)
    {
      setType("text")
     return;
    }
    setType(masking_type)
  }

  const checkPreviousEnteredEmails = async (id) => {
    setUniqueDataError(false);
    existingEmails.forEach((item, index) => {
      if (item[id] === currentEmail && index !== editIndex) {
        setUniqueDataError(true);
      }
    });
  };
  //used in eval
  const concatenateFields = (data, extractedData, keyName) => {
    mergeFields(data, extractedData, keyName, dispatch, setSelectedData);
  };

  const handleExpression = async (data, expression) => {
    let response;
      response = await getDataBasedOnExpression(data,expression)
      if (response.status == 'success') {

        autofill?.forEach((item) => {
          dispatch(
            setSelectedData({
              key: [`${item?.destination_field}`],
              value: response?.data?.response?.[`${item?.source_field}`],
            })
          );
        });
      }
  }

  const checkDuplicate = async (data) => {
    let response;
    response = await (getDuplicateData(data));
    if(response?.response?.data?.length == 1 && response?.response?.data[0]?._id == workflow_id ){
      dispatch(setIsDuplicateFormInput({ [name]: false }));
      dispatch(setSelectedData({key : [`${name}_duplicated`], value : false  }));
      dispatch(setSelectedData({key : "previous_data", value : response?.previous_data}));
      dispatch(setSelectedData({key : "previous_data_id", value : data?.name  }));
    }
   else if (response?.response.status?.toLowerCase() == 'success' && !!response?.response?.data.length) {
      dispatch(setIsDuplicateFormInput({ [name]: true }));
      dispatch(setSelectedData({key :  [`${name}_duplicated`], value : true }));
      dispatch(setSelectedData({key : "previous_data", value : response?.previous_data}));
      dispatch(setSelectedData({key : "previous_data_id", value : data?.name  }));
    }
    else if (response?.response.status?.toLowerCase() == 'success' && response?.response?.data.length == 0) {
      dispatch(setSelectedData({  key : [`${name}_duplicated`], value : false }));
      dispatch(setIsDuplicateFormInput({ [name]: false }) );
      dispatch(setSelectedData({key : "previous_data", value : response?.previous_data}));
      dispatch(setSelectedData({key : "previous_data_id", value : data?.name  }));
    }
  }

  const docNumberExtraction = async (data, docType) => {
    let result;
    let response;
    if ((data?.length == doc_id_length)) {
      setIsUploading(true);
      let dob = subworkflows?.birth_date;
      dob = dob?.split("/").reverse().join("-");
      autofill?.forEach((item) => {
        dispatch(
          setSelectedData({
              key: [`${item?.destination_field}`], value: "" 
          })
        );
      });
      let state = subworkflows?.shop_establishment_state;
      result = await verifyDocumentNumber({
        data,
        docType,
        verify,
        dob,
        selectedData,
        verification_id,
        subworkflows,
        state,
        doc_number_validation,
        substring_exprn
      });
      if (result?.status === "success") {
        dispatch(
          setVerificationResponse({
            key: verification_id,
            value: result || result?.data,
          })
        );

        autofill?.forEach((item) => {
          dispatch(
            setSelectedData({
              key: [`${item?.destination_field}`],
              value: eval(`result?.data?.${item?.source_field}`),
            })
          );
        });
        if ((result?.data?.gstin_status != 'Active')) {          
          setGstInactiveError(true);
        } else {
          setGstInactiveError(false);
        }
        const message = result?.message ? result?.message : "Document Number extracted successfully";
        setMessageToast({type: "success",msg: message});
        setTimeout(() => {
            setMessageToast(null);
        }, 2000);
        setIsUploading(false);
      }
       else {
        setIsUploading(false);
        dispatch(setSelectedData({ key: name, value: "" }));
        const errorMessage = result?.message ? result?.message : "Invalid Number, Please enter a valid file";
        setMessageToast({type: "error",msg: errorMessage});
        setTimeout(() => {
          setMessageToast(null);
        }, 2000);
      }
    }
  };



  useEffect(() => {
    dispatch(setIsKeyDuplicate(uniqueDataError));
  }, [uniqueDataError]);

  return (
    <div className={size}>
      {messageToast?.msg && (
        <Toast message={messageToast?.msg} type={messageToast?.type} id="unique-toast-id" />

      )}
      {label ? (
        <Label label={label} tooltip={tooltip} validators={validators} />
      ) : (
        <div className="mt-2" />
      )}

      {!isUploading ? (
        <>
        <div className="position-relative">
          <input
            type={newType}
            name={name}
            className={`form-input  ${
              uniqueDataError ? "duplicate_error" : ""
            } ${!isEditable && "radioDisabled"} ${errorClass}`}
            placeholder={placeholder}
            value={value || ""}
            // FOR DISABLE WHEN IsEditable IS TRUE then the input should not be disabled when isEditable is false then check if isToggled is true then the input should be disabled
            disabled={
              is_disabled && eval(is_disabled)
                ? true
                : !isEditable ||
                  (isToggled && copiedData?.[name] !== undefined) ||
                  (disabled && IndirectEval(disabled))
            }
            onChange={onChange}
            onKeyUpCapture={onKeyUpCapture}
            // onBlur={onBlurCapture}
          />
          {
            masking_type   ?  <Image className = 'position-absolute top-50 end-0 translate-middle' imageSrc={newType == 'password' ?  show_password :  hide_password}  onClick={togglePassword}/> : ''
          }
         
        </div>
        {uniqueDataError ? (
            <span className="duplicate_code_error">Email should be unique</span>
          ) : null}
          {gstInactiveError ? (
            <span className="duplicate_code_error">{error_messages?.inactive_error}</span>
          ) : null}
          {error?.length !== 0 && <ErrorMessage error={error} />}
          {isDuplicateFormInput[name] == true && (selectedData[name]?.length > 0) ? <span className='duplicate_code_error'>{error_messages?.duplicate_error}</span> : null}

        </>
      ) : (
        <div className="position-relative">
          <input
            type={type}
            name={name}
            className={`form-input form-input-spinner`}
            placeholder={placeholder}
          />
          <div class="spin-loader position-absolute">Loading...</div>
        </div>
      )}
    </div>
  );
};

export default Input;
